import { Box, Drawer, IconButton } from "@mui/material";
import { useRef, useEffect, useState } from 'react'
import NavBox from "./NavBox";
import MenuIcon from '@mui/icons-material/Menu'
import AuthBox from "../AuthBox";

const MainNav = ({ isMobile }) => {
    const [drawerOpen, setDrawerOpen] = useState(false)

    const handleDrawer = () => {
        if (drawerOpen) {
            setDrawerOpen(false)
        } else {
            setDrawerOpen(true)
        }
    }

    return (
        <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            p={2}
            sx={{
                backgroundColor: '#1e1e1e'
            }}
            mb={2}
        >
            {
                isMobile && (
                    <>
                        <IconButton
                            onClick={handleDrawer}
                        >
                            <MenuIcon />
                        </IconButton>
                    </>
                )
            }
            {isMobile && (
                <Drawer
                    anchor="left"
                    open={drawerOpen}
                    onClose={() => setDrawerOpen(false)}
                    PaperProps={{ style: { width: 250 } }}
                >
                    <NavBox isMobile={isMobile} drawer={handleDrawer} />
                </Drawer>
            )}
            {
                !isMobile && 
                <NavBox isMobile={isMobile} />
            }
            <AuthBox />
        </Box>
    );
};

export default MainNav;